import React from "react";

export default function HamburgerButton({ open, onClick }) {
  return (
    <button
      type="button"
      className={`hamburger-btn ${open ? "open" : ""}`}
      onClick={onClick}
      aria-label="Toggle navigation menu"
      aria-expanded={open}
    >
      <span />
      <span />
      <span />
    </button>
  );
}